import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { JsonHttpService } from '../../shared/http/json-http.service'
import { UserSetting } from '../models/user-setting';

@Injectable({
    providedIn: 'root'
})
export class UserSettingsService {

    constructor(private httpService: JsonHttpService) { }

    /**
     * Gets all the settings for the current user
     */
    public getUserSettings(): Promise<UserSetting[]> {
        return this.httpService.get('/api/users/settings/get-settings').toPromise();
    }

    /**
     * Gets all the settings for the given groupKey and the current user.
     * @param groupKey The key for the group to get settings for
     */
    public getUserSettingsByGroup(groupKey: string): Promise<UserSetting[]> {
        const options = groupKey ? { params: new HttpParams().set('groupKey', groupKey) } : {};
        return this.httpService.get('/api/users/settings/get-settings-by-group', options).toPromise();
    }

    /**
     * Gets a single setting from the given settingKey
     * @param settingKey The key to get the setting for
     */
    public getSingleSetting(settingKey: string): Promise<UserSetting> {
        const options = settingKey ? { params: new HttpParams().set('settingKey', settingKey) } : {};
        return this.httpService.get('/api/users/settings/get-single-setting', options).toPromise();
    }

    /**
     * Saves the given settings
     * @param settings The settings to save
     */
    public saveSettings(settings: UserSetting[]): Promise<void> {
        return this.httpService.post('/api/users/settings/save-settings', settings).toPromise();
    }

    /**
     * Saves the given setting
     * @param setting The setting to save
     */
    public saveSingleSettings(setting: UserSetting): Promise<void> {
        return this.httpService.post('/api/users/settings/save-single-setting', setting).toPromise();
    }

    /**
    * Saves the given setting
    * @param setting The setting to save
    */
    public deleteSetting(settingKey?: string, groupKey?: string): Promise<void> {
        const options = {
            params: new HttpParams()
        };

        if (settingKey != null) {
            options.params = options.params.set('settingKey', settingKey)
        }

        if (groupKey != null) {
            options.params = options.params.set('groupKey', groupKey)
        }
        return this.httpService.post('/api/users/settings/delete-settings', null, options).toPromise();
    }
}
